// extracted by mini-css-extract-plugin
export default {"parent":"Gachapon-Balance_parent__a9CAM","button":"Gachapon-Balance_button__E6SFS","balance":"Gachapon-Balance_balance__IJ5ri"};